import { Link } from "react-router-dom";
import { Logo } from "@/components/site/Logo";
import { BRAND, LINKS, MENU } from "@/lib/content";

export const Footer = () => (
  <footer className="no-print border-t border-slate-800 bg-black" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4">
      <div className="md:col-span-2">
        <Logo />
        <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
          Tratamento de ruídos e isolamento termoacústico para veículos, geradores e embarcações. {BRAND.frase}
        </p>
        <p className="mt-6 font-heading text-2xl font-bold text-white">{BRAND.telefone}</p>
        <p className="font-mono text-xs uppercase tracking-wider text-red-400">WhatsApp · Atendimento {BRAND.atendimento}</p>
      </div>
      <div>
        <p className="eyebrow mb-4">Navegação</p>
        <ul className="space-y-2 text-sm">
          {MENU.map((m) => (
            <li key={m.to}><Link to={m.to} className="text-slate-400 transition-colors hover:text-white">{m.label}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <p className="eyebrow mb-4">Links rápidos</p>
        <ul className="space-y-2 text-sm">
          {LINKS.map((l) => (
            <li key={l.url}><a href={l.url} target="_blank" rel="noreferrer" className="text-slate-400 transition-colors hover:text-white">{l.titulo}</a></li>
          ))}
          <li className="text-slate-500">Instagram {BRAND.instagram} · Facebook {BRAND.facebook}</li>
        </ul>
        <Link to="/admin" data-testid="footer-admin-link" className="mt-6 inline-block font-mono text-[11px] uppercase tracking-wider text-slate-600 hover:text-slate-300">
          Área do prestador
        </Link>
      </div>
    </div>
    <div className="border-t border-slate-900 py-5 text-center font-mono text-[11px] uppercase tracking-wider text-slate-600">
      Nillo Ruídos — {BRAND.slogan} {BRAND.assinatura}
    </div>
  </footer>
);
